import React from "react";
import {
  TextField,
  TableRow,
  TableCell,
  Typography,
  Tooltip,
} from "@mui/material";

// コンポーネントの Props の型
type SimSerialNoInputRowProps = {
  index: number;
  simId: string;
  serialNo: string;
  result?: string;
  handleChange: (
    index: number,
    field: "simId" | "serialNo",
    value: string
  ) => void;
};

const SimSerialNoMappingInputForm: React.FC<SimSerialNoInputRowProps> =
  React.memo(({ index, simId, serialNo, result, handleChange }) => {
    return (
      <Tooltip title={result !== "OK" ? result : ""}>
        <TableRow
          key={index}
          sx={{
            backgroundColor:
              result === "OK" ? "inherit" : "rgba(255, 0, 0, 0.2)",
          }}
        >
          <TableCell
            sx={{
              padding: "2px 4px",
              verticalAlign: "middle",
            }}
          >
            <Typography>{index + 1}</Typography>
          </TableCell>
          <TableCell
            sx={{
              padding: "2px 4px",
              verticalAlign: "middle",
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              margin="dense"
              value={simId}
              inputProps={{ maxLength: 15 }}
              onChange={(e) => handleChange(index, "simId", e.target.value)}
              sx={{
                "& .MuiInputBase-root": {
                  padding: "2px",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "2px",
                },
              }}
            />
          </TableCell>
          <TableCell
            sx={{
              padding: "2px 4px",
              verticalAlign: "middle",
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              margin="dense"
              value={serialNo}
              inputProps={{ maxLength: 6 }}
              onChange={(e) => handleChange(index, "serialNo", e.target.value)}
              sx={{
                "& .MuiInputBase-root": {
                  padding: "2px",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "2px",
                },
              }}
            />
          </TableCell>
        </TableRow>
      </Tooltip>
    );
  });

export default SimSerialNoMappingInputForm;
